<template>
  <div class="block">
    <h1
      v-if="title"
      class="has-text-centered has-text-primary pt-6 pb-4 is-mobile"
      :class="width < 768 ? 'is-size-3' : 'is-size-1'"
      style="font-family: Calibri; font-weight: bold"
    >
      {{ title }}
    </h1>
    <div class="columns is-centered is-mobile">
      <div class="column is-two-thirds">
        <p
          class="has-text-primary has-text-centered is-size-6 is-mobile"
          style="font-family: Calibri; font-weight: bold"
        >
          {{ text }}
        </p>
      </div>
    </div>
    <div class="level is-mobile pt-4">
      <div v-if="label" class="level-item level-left">
        <p
          class="has-text-primary is-size-5 is-mobile"
          style="font-family: Calibri; font-weight: bold"
        >
          {{ label }}
        </p>
      </div>
      <div class="level-item level-right has-text-right">
        <svg-icon
          @click="previousPage"
          class="has-text-yellow"
          type="mdi"
          :path="mdiMenuLeft"
          style="width: 50px; height: 50px"
        ></svg-icon>
        <svg-icon
          @click="nextPage"
          class="has-text-yellow"
          type="mdi"
          :path="mdiMenuRight"
          style="width: 50px; height: 50px"
        ></svg-icon>
      </div>
    </div>
  </div>
  <div class="block pb-6">
    <div class="columns is-mobile">
      <div v-for="(equipo, index) in equiposPage" :key="index" class="column">
        <div v-if="equipo.img" class="card equipo-card">
          <div class="card-image">
            <img :src="equipo.img" :alt="equipo.alt" />
          </div>
          <div class="card-content">
            <p
              class="has-text-primary is-size-6"
              style="font-family: Calibri; font-weight: bold"
            >
              {{ equipo.nombre }}
            </p>
            <p
              class="is-size-6 has-text-green"
              style="font-family: Calibri; font-weight: bold"
            >
              {{ equipo.codigo }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiMenuLeft, mdiMenuRight } from "@mdi/js";
import { Equipo, useEquipos } from "@/use-equipos";
import { ref } from "vue";
import { useWindowSize } from "vue-window-size";

const props = defineProps<{
  title?: string;
  text?: string;
  label?: string;
  clasification: string;
}>();

const { width } = useWindowSize();
const { getEquiposByClasificacion } = useEquipos();
const equipos = getEquiposByClasificacion(props.clasification);
const equiposSize = equipos.length;
const pages = Math.ceil(equiposSize / 3);
const currentPage = ref(1);
const equiposPage = ref(getEquiposPerPage(currentPage.value));

function getEquiposPerPage(page: number) {
  const initialPos = page === 1 ? 0 : page * 3 - 3;
  const finalPos = initialPos + 3 < equiposSize ? initialPos + 3 : equiposSize;
  let equiposArray = equipos.slice(initialPos, finalPos);
  const equiposLength = equiposArray.length;
  if (equiposLength < 3) {
    for (let index = 0; index < 3; index++) {
      const element = equiposArray[index];
      if (!element) {
        equiposArray.push({} as Equipo);
      }
    }
  }
  console.log(equiposArray);
  return equiposArray;
}

function nextPage() {
  currentPage.value = currentPage.value < pages ? currentPage.value + 1 : 1;
  equiposPage.value = getEquiposPerPage(currentPage.value);
}

function previousPage() {
  currentPage.value = currentPage.value > 1 ? currentPage.value - 1 : pages;
  equiposPage.value = getEquiposPerPage(currentPage.value);
}
</script>
